$(function() {
    $('#btn-update-appointment').on('click', function() {
        $("#content-update-appointment").slideToggle("medium", function() {
            if ($(this).is(':visible')){
                $(this).css('display','block');
            } 
        });
    });

    $('#btn-create-appointment').on('click', function() {
        var href = $(this).attr('href');
        //recuperem els paràmetres UTM i els afegim a l'url per no perdre'ls al redireccionar
        var currentParams = new URLSearchParams(window.location.search);
        var hrefUrl = new URL(href, window.location.origin);
        currentParams.forEach((value, key) => {
            hrefUrl.searchParams.append(key, value);
        });
        href = hrefUrl.toString();     
        window.open(href, "_self");
    });

    $('#appointment_code').val('');

    $('#btn-search-appointment').on('click', function() {
        $('.appointment-found').hide();
        $('.appointment-found-false.error-search').hide();
        $('.appointment-found-false.error-search').find('#appointment-found-error-container').html("");

        //need to check if input is not empty and no scripts etc,
        if($('#appointment_code').val() == '') {
            $('.appointment-found-false.error-search').show();
            $('.appointment-found-false.error-search').find('#appointment-found-error-container').html("Es necesario el código de la cita");
        } else {
            $.ajax({
                url: $('#url-base-lang').val()+$('#dealer').val()+"/index/search",
                data: "dealer="+$('#dealer').val() +"&code=" + $('#appointment_code').val(),
                type: 'POST',
                beforeSend: function() {
                   $('#btn-update-appointment').prop('disabled', true);
                   $('#btn-search-appointment').prop('disabled', true);
                   $('#btn-search-appointment .fa-spin').show();
                }, 
                success: function(result) {
                    $('#btn-update-appointment').prop('disabled', false);
                    $('#btn-search-appointment').prop('disabled', false);
                    $('#btn-search-appointment .fa-spin').hide();
                    if(result==1) {
                        $('.appointment-found').show();
                        location.href = $('#url-base-lang').val()+$('#dealer').val()+"/"+$('#appointment_code').val();
                    } else {
                        $('.appointment-found-false.error-search').show();
                        $('.appointment-found-false.error-search').find('#appointment-found-error-container').html("No se ha encontrado ninguna cita para este código");
                    }
                    return false;
                }
            });
        }
    });
});